import axios from "axios";
import { encryptData, decryptData } from "../utils/cryptoEncryptApiData";
//const getPosts = () => api.get("/posts");
//const deletePost = (id) => api.delete(`posts/${id}`);

function formDataToObject(formData) {
  const obj = {};
  for (const [key, value] of formData.entries()) {
    obj[key] = value;
  }
  return obj;
}
function objectToFormData(encryptedPayload) {
  const formDataToSend = new FormData();
  if (encryptedPayload) {
    formDataToSend.append("request_data", encryptedPayload); // You can choose any key name
  }
  return formDataToSend;
}

const postData = async (base_url, target, data, headers = {}) => {
  try {
    const plainObject = formDataToObject(data);

    // Encrypt payload if data is provided
    const encryptedPayload = data
      ? await encryptData(JSON.stringify(plainObject))
      : null;

    // Encrypt custom headers

    const encryptedHeaders = {};
    for (const [key, value] of Object.entries(headers)) {
      if (typeof value === "string") {
        encryptedHeaders[key] = await encryptData(value);
      } else {
        encryptedHeaders[key] = await encryptData(JSON.stringify(value));
      }
    }

    const postApi = axios.create({
      baseURL: base_url,
      //headers: encryptedHeaders,
      headers: headers,
    });

    const response = await postApi.post(
      target,
      objectToFormData(encryptedPayload)
    );
   
    // Decrypt the response.data assuming it's Base64-encoded string
    if (
      response?.data &&
      typeof response.data === "object" &&
      typeof response.data.data === "string"
    ) {  
      const decrypted = await decryptData(response.data.data);
      delete response.data.data; // remove original encrypted key
      Object.assign(response.data, decrypted); // merge decrypted data into response.data
    } /* else {
      throw new Error("Response data not decryptable:", response.data);
    }*/
    return response;
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      //  console.error("Request timed out !");
    } else {
      //  console.error("An error occurred: ", error);
    }
  }
};
const decryptResponseData = async (response) => {
  if (response && typeof response === "string") {
    try {
      const decrypted = await decryptData(response); // Wait for the decryption to complete
      response = null; // Clear the original encrypted key
      return decrypted; // Return the decrypted data directly
    } catch (error) {
      throw new Error("Response data not decryptable:", error);
    }
  } else {
    throw new Error("Invalid response data:", response);
  }
};
const getAPIData = async (base_url, target, headers = {}) => {
  try {
    // Encrypt custom headers
    const encryptedHeaders = {};
    for (const [key, value] of Object.entries(headers)) {
      if (typeof value === "string") {
        encryptedHeaders[key] = await encryptData(value);
      } else {
        encryptedHeaders[key] = await encryptData(JSON.stringify(value));
      }
    }

    const getapi = axios.create({
      baseURL: base_url,
      headers: encryptedHeaders,
    });

    const response = await getapi.get(target, {
      timeout: 5000, // Timeout after 5000ms (1 min)
    });

    // Decrypt the response.data from api response assuming it's Base64-encoded string
    if (
      response?.data &&
      typeof response.data === "object" &&
      typeof response.data.response_data === "string"
    ) {
      const decrypted = await decryptData(response.data.response_data);
      delete response.data.response_data; // remove original encrypted key
      Object.assign(response.data, decrypted); // merge decrypted data into response.data
    } /*else {
      throw new Error("Response data not decryptable:", response.data);
    }*/
   
    return response;
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      // console.error("Request timed out !");
    } else {
      //  console.error("An error occurred: ", error);
    }
  }
};

//const updatePost = (id, post) => api.put(`/posts/${id}`, post);

//export { getPosts, deletePost, createPost, updatePost };
export { postData, decryptResponseData, getAPIData };
